import React, { HTMLProps, PropsWithChildren } from 'react';
import { Icon } from '@geberit/gdds';
import { StyledLink } from './nav-item.styles';
import type { UrlObject } from 'url';

type NavItemProps = PropsWithChildren<{
  href: UrlObject | string;
  isOption?: boolean;
  selected?: boolean;
  shallow?: boolean;
  leftIconUrl?: string | false;
  leftIconName?: string | false;
  rightIconName?: string | false;
  hasPictogram?: boolean;
  withPictogram?: boolean;
  firstLevel?: boolean;
  thirdLevel?: boolean;
  isOverviewItem?: boolean;
}> &
  HTMLProps<HTMLAnchorElement>;

export function NavItem({
  selected,
  leftIconName,
  rightIconName,
  shallow,
  children,
  isOption,
  as,
  ...anchorProps
}: NavItemProps) {
  function getIconPosition() {
    if (leftIconName && rightIconName) {
      return 'both';
    }
    if (leftIconName) {
      return 'left';
    }
    if (rightIconName) {
      return 'right';
    }
    return 'none';
  }

  return (
    <StyledLink
      shallow={shallow}
      className={selected ? 'selected' : undefined}
      selected={selected}
      $isOption={isOption}
      $iconPosition={getIconPosition()}
      {...anchorProps}
    >
      {leftIconName && <Icon className="first-icon" symbol={leftIconName} />}
      {children}
      {rightIconName && <Icon className="last-icon" symbol={rightIconName} />}
    </StyledLink>
  );
}
